<template>
  <div class="laundry-room">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>洗衣房管理</span>
        <div class="header-buttons">
          <el-button type="primary" @click="showAddDialog" icon="el-icon-plus">添加</el-button>
          <el-button type="success" @click="refreshList" icon="el-icon-refresh">刷新</el-button>
        </div>
      </div>

      <!-- 筛选条件 -->
      <div class="filter-section" style="margin-bottom: 20px;">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-select
              v-model="filterSchoolId"
              placeholder="选择学校筛选"
              clearable
              style="width: 100%;"
              @change="filterBySchool"
            >
              <el-option label="全部学校" value=""></el-option>
              <el-option
                v-for="item in schoolList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-col>
        </el-row>
      </div>

      <!-- 洗衣房列表 -->
      <el-table
        :data="filteredLaundryList"
        style="width: 100%;"
        v-loading="tableLoading"
        @selection-change="handleSelectionChange"
        ref="laundryTable"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="school_name" label="所属学校" min-width="120"/>
        <el-table-column prop="name" label="洗衣房名称" min-width="120"/>
        <el-table-column prop="address" label="地址" min-width="200"/>
        <el-table-column prop="description" label="描述" min-width="120"/>
        <el-table-column prop="created_at" label="创建时间" width="180" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="qrcode_url" label="二维码" width="120" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.qrcode_url">
              <img
                :src="getImageUrl(scope.row.qrcode_url)"
                alt="二维码"
                style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px; margin-right: 8px;"
              />
              <el-button size="mini" type="success" @click="viewQRCode(scope.row.qrcode_url)">查看二维码</el-button>
            </div>
            <el-button v-else size="mini" type="primary" @click="generateQR(scope.row.id)">
              生成二维码
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="deleteLaundry(scope.row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-button type="primary" @click="downloadSelectedQRCodes" :disabled="multipleSelection.length === 0" style="margin-top: 10px;">
        批量下载二维码
      </el-button>
      <el-button type="success" @click="downloadAllQRCodes" style="margin-top: 10px;">
        下载全部二维码
      </el-button>
    </el-card>

    <!-- 添加洗衣房弹窗 -->
    <el-dialog title="添加洗衣房" :visible.sync="addDialogVisible" width="600px" @close="resetForm">
      <el-form :model="form" :rules="rules" ref="laundryForm" label-width="100px">
        <el-form-item label="所属学校" prop="school_id">
          <el-select v-model="form.school_id" placeholder="请选择学校" style="width: 100%;">
            <el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="洗衣房名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入洗衣房名称"></el-input>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="form.address" placeholder="请输入详细地址"></el-input>
        </el-form-item>
        <el-form-item label="描述信息">
          <el-input v-model="form.description" placeholder="请输入描述信息（可选）"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="addLaundry" :loading="loading">确定</el-button>
      </div>
    </el-dialog>

    <!-- 二维码弹窗 -->
    <el-dialog title="二维码" :visible.sync="qrDialogVisible" width="30%">
      <div style="text-align: center;">
        <img :src="getImageUrl(currentQRCodeUrl)" alt="二维码" style="max-width: 100%; max-height: 400px;"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

export default {
  name: 'LaundryRoom',
  data() {
    return {
      baseURL: "https://stwc7777.com",
      // baseURL: "http://localhost:8090",
      loading: false,
      tableLoading: false,
      addDialogVisible: false,

      // 洗衣房表单
      form: {
        school_id: '',
        name: '',
        address: '',
        description: ''
      },
      rules: {
        school_id: [
          {required: true, message: '请选择所属学校', trigger: 'change'}
        ],
        name: [
          {required: true, message: '请输入洗衣房名称', trigger: 'blur'},
          {min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur'}
        ],
        address: [
          {required: true, message: '请输入详细地址', trigger: 'blur'},
          {min: 5, max: 255, message: '长度在 5 到 255 个字符', trigger: 'blur'}
        ]
      },

      // 数据列表
      schoolList: [],
      laundryList: [],
      filteredLaundryList: [],
      multipleSelection: [],
      qrDialogVisible: false,
      currentQRCodeUrl: '',

      // 筛选条件
      filterSchoolId: '',
      userRole: window.sessionStorage.getItem('userRole')
    }
  },
  created() {
    this.getSchoolList()
    this.getLaundryList()
  },
  methods: {
    getImageUrl(url) {
      return this.baseURL + url;
    },
    // 显示添加弹窗
    showAddDialog() {
      this.addDialogVisible = true
    },
    // 刷新列表
    refreshList() {
      this.getLaundryList()
    },
    // 获取学校列表
    async getSchoolList() {
      try {
        const {data: res} = await this.$http.get('/api/school/list')
        if (res.status !== 0) return this.$message.error('获取学校列表失败')
        this.schoolList = res.data
      } catch (error) {
        this.$message.error('获取学校列表失败')
      }
    },
    // 添加洗衣房
    addLaundry() {
      this.$refs.laundryForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            const {data: res} = await this.$http.post('/api/laundry/add', this.form)
            if (res.status !== 0) return this.$message.error('添加失败')
            this.$message.success('添加成功')
            this.addDialogVisible = false
            this.resetForm()
            this.getLaundryList()
          } catch (error) {
            this.$message.error('添加失败')
          } finally {
            this.loading = false
          }
        }
      })
    },

    // 获取洗衣房列表
    async getLaundryList() {
      this.tableLoading = true
      try {
        const {data: res} = await this.$http.get('/api/laundry/list')
        if (res.status !== 0) return this.$message.error('获取洗衣房列表失败')
        this.laundryList = res.data
        this.applyFilter()
      } catch (error) {
        this.$message.error('获取洗衣房列表失败')
      } finally {
        this.tableLoading = false
      }
    },

    // 按学校筛选
    filterBySchool() {
      this.applyFilter()
    },

    // 应用筛选条件
    applyFilter() {
      // 如果是学校管理者，不需要筛选，因为后端已经限制了数据
      if (this.userRole === 'school_manager') {
        this.filteredLaundryList = [...this.laundryList]
        return
      }

      if (!this.filterSchoolId) {
        // 不筛选，显示全部
        this.filteredLaundryList = [...this.laundryList]
      } else {
        // 按学校筛选
        this.filteredLaundryList = this.laundryList.filter(item =>
          item.school_id == this.filterSchoolId
        )
      }
    },

    // 生成二维码
    async generateQR(id) {
      try {
        const {data: res} = await this.$http.get(`/api/laundry/qrcode/${id}`)
        if (res.status !== 0) return this.$message.error('二维码生成失败')
        this.$message.success('二维码生成成功')
        await this.getLaundryList()
      } catch (error) {
        this.$message.error('二维码生成失败')
      }
    },

    // 删除洗衣房
    deleteLaundry(id) {
      this.$confirm('此操作将永久删除该洗衣房及其相关记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const {data: res} = await this.$http.delete(`/api/laundry/delete/${id}`)
          if (res.status !== 0) return this.$message.error('删除失败')
          this.$message.success('删除成功')
          this.getLaundryList()
        } catch (error) {
          this.$message.error('删除失败')
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    // 重置表单
    resetForm() {
      this.$refs.laundryForm.resetFields()
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN')
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    async downloadSelectedQRCodes() {
      if (this.multipleSelection.length === 0) return;
      await this.downloadQRCodesAsZip(this.multipleSelection);
    },

    async downloadAllQRCodes() {
      await this.downloadQRCodesAsZip(this.laundryList.filter(item => item.qrcode_url));
    },

    async downloadQRCodesAsZip(list) {
      const zip = new JSZip();
      const fetchImage = async (url) => {
        const response = await fetch(this.baseURL + url);
        return await response.blob();
      };
      for (const item of list) {
        if (item.qrcode_url) {
          const blob = await fetchImage(item.qrcode_url);
          zip.file(`洗衣房_${item.name}_二维码.png`, blob);
        }
      }
      const content = await zip.generateAsync({ type: 'blob' });
      saveAs(content, '洗衣房二维码.zip');
    },

    viewQRCode(url) {
      this.currentQRCodeUrl = url;
      this.qrDialogVisible = true;
    }
  }
}
</script>

<style scoped>
.laundry-room {
  padding: 20px;
}

.box-card {
  margin-bottom: 20px;
}

.header-buttons {
  float: right;
}

.header-buttons .el-button {
  margin-left: 10px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>